var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0022 9C10.5581 9 11.0913 8.78929 11.4843 8.41421C11.8774 8.03914 12.0982 7.53043 12.0982 7C12.0982 6.46957 11.8774 5.96086 11.4843 5.58579C11.0913 5.21071 10.5581 5 10.0022 5C9.44635 5 8.91323 5.21071 8.52015 5.58579C8.12708 5.96086 7.90625 6.46957 7.90625 7C7.90625 7.53043 8.12708 8.03914 8.52015 8.41421C8.91323 8.78929 9.44635 9 10.0022 9Z",
    fill: "var(--klothed-tile-textColor)",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7C1.33515 2.943 5.30706 0 10 0C14.6929 0 18.6649 2.943 20 7C18.6649 11.057 14.6929 14 10 14C5.30706 14 1.33515 11.057 0 7ZM14.192 7C14.192 8.06087 13.7503 9.07828 12.9642 9.82843C12.178 10.5786 11.1118 11 10 11C8.88821 11 7.82196 10.5786 7.03581 9.82843C6.24966 9.07828 5.80801 8.06087 5.80801 7C5.80801 5.93913 6.24966 4.92172 7.03581 4.17157C7.82196 3.42143 8.88821 3 10 3C11.1118 3 12.178 3.42143 12.9642 4.17157C13.7503 4.92172 14.192 5.93913 14.192 7Z",
    fill: "var(--klothed-tile-textColor)",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.0d239375539913ba224232fbc4c79174.svg";
export { ForwardRef as ReactComponent };